import { css } from 'lit';

export const nsCardStyles = css`
  .card.stacked {
    grid-template-areas: 'header' 'body' 'buttons';
  }

  .card.stacked .buttons .layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .summary-card {
    padding: var(--wa-space-m);
    border-radius: 0.5em;
    background: var(--wa-color-surface-default);
    color: var(--wa-color-text-normal);
  }

  .card {
    position: relative;

    background: var(--ns-card-background, var(--wa-color-surface-default));
    border-radius: var(--ns-card-border-radius, 0.5em);
    margin-bottom: 1em;
    color: var(--ns-card-color, var(--wa-color-text-normal));

    padding: var(--wa-space-s);

    display: grid;
    grid-template-columns: 2fr auto;
    grid-template-rows: auto 1fr;
    gap: 0.2em 1em;
    grid-auto-flow: row;
    grid-template-areas:
      'header buttons'
      'body buttons';
  }

  .card.job {
    grid-template-areas:
      'header buttons'
      'body buttons';
  }
  .card.post {
    grid-template-areas:
      'header'
      'image'
      'buttons';
  }
  .card .header {
    grid-area: header;
  }
  .card .header .title {
    font-size: 1.2em;
  }
  .card .header .under-title {
    font-size: 0.7em;
  }
  .card .image {
    grid-area: image;
    width: auto;
    height: 300px;

    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    margin: 0px -29px 0 -13px;
  }
  .card .body {
    grid-area: body;
    font-size: 0.8em;
  }
  .card .body .tags {
    margin-bottom: 0.2em;
  }
  .card .body .tags .tag {
    background: var(--ns-theme-red);
    display: inline-block;
    border-radius: var(--wa-border-radius-l);
    padding: var(--wa-space-3xs) var(--wa-space-xs);
    font-size: 0.8em;
  }
  .card .buttons {
    display: grid;
    align-content: space-between;

    grid-area: buttons;

    position: relative;
    z-index: 1;
  }
  .card .card-hit-target {
    position: absolute;
    inset: 0;
    z-index: 0;

    border: none;
    margin: 0;
    padding: 0;

    background: none;
    appearance: none;
    cursor: pointer;
  }
  .card .buttons .icon-button {
    --icon-height: 1.2em;
    --icon-width: 1.2em;
    --ns-button-padding: var(--wa-space-2xs);
    --ns-button-height: auto;
    --ns-button-min-width: auto;
  }
  .card .buttons .icon-button button {
    padding: var(--wa-space-2xs);
    height: auto;
    width: auto;
    min-width: 0;
  }
  /* Figma's time indicator: a green pill over the card's top edge */
  .card .timer {
    position: absolute;
    top: -0.7em;
    left: 1em;

    display: flex;
    align-items: center;
    gap: var(--wa-space-3xs);

    padding: var(--wa-space-3xs) var(--wa-space-xs) var(--wa-space-3xs) var(--wa-space-3xs);
    border-radius: var(--wa-border-radius-l);
    background: var(--wa-color-success-fill-loud);
    color: var(--wa-color-success-on-loud);

    font-size: var(--wa-font-size-3xs);
    font-weight: 300;
    line-height: 1;
  }
  .card .timer .time-icon {
    width: 12px;
    height: 12px;
  }

  .card.loading .header .title,
  .card.loading .header .under-title {
    background: var(--ns-theme-grey-mid);
    background: linear-gradient(
      110deg,
      var(--ns-theme-grey-mid) 8%,
      var(--ns-theme-background) 18%,
      var(--ns-theme-grey-mid) 33%
    );
    border-radius: var(--wa-border-radius-m);
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
    width: 100%;
  }

  .card.loading .header .title {
    height: 2em;
  }
  .card.loading .header .under-title {
    height: 1.3em;
    margin-top: 0.5em;
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
`;
